
import React from 'react';
import './TrainingForm.css';
import bg1 from '../Components/images/bg1.jpg'
import { FaArrowLeft } from "react-icons/fa";
import { Link } from 'react-router-dom';

const TrainingForm = () => {
  return (
    <div className='fcontainer'>
         <div className="top-left-container">
        <Link to="/" className="top-left-btn">
          <FaArrowLeft />
        </Link>
      </div>
    <div className="form-container">
      <img className="form-title-img" src={bg1} alt='coming soon' />

      <h2 className="form-title">Application Form</h2>
      <form className="form-inline">
        <label>
          Your Name:
          <input type="text" name="name" />
        </label>
        <label>
          Your Email:
          <input type="email" name="email" />
        </label>
        <label>
          Phone No:
          <input type="tel" name="phone" />
        </label>
        <label>
          Gender:
          <select name="gender">
            <option value="male">Male</option>
            <option value="female">Female</option>
            <option value="other">Other</option>
          </select>
        </label>
        <label>
          Address:
          <input type="text" name="state" />
        </label>
        <label>
          Pincode:
          <input type="text" name="pincode" />
        </label>
       
          
      </form>
      <button className="submit-btn" type="submit">Submit</button>
    </div>

    </div>
  );
}

export default TrainingForm;
